import * as tslib_1 from "tslib";
import { HttpClient, HttpParams } from '@angular/common/http';
import { InterfaceService } from '@app/interfaces';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var DiaryTasksService = /** @class */ (function (_super) {
    tslib_1.__extends(DiaryTasksService, _super);
    function DiaryTasksService(http) {
        var _this = _super.call(this) || this;
        _this.http = http;
        return _this;
    }
    /**
     * Fetch onsite tasks for a specific diary event
     * @param diaryId - The diary event ID
     * @param status - Filter by status: 'incomplete', 'completed', 'skipped', or null for all
     * @param searchTerm - Optional search term to filter tasks
     */
    DiaryTasksService.prototype.getOnsiteTasks = function (diaryId, status, searchTerm) {
        var params = new HttpParams();
        if (status !== undefined && status !== null) {
            params = params.set('status', status);
        }
        if (searchTerm && searchTerm.trim()) {
            params = params.set('search', searchTerm.trim());
        }
        return this.http.get(this.getJobApiUrl("diary/" + diaryId + "/onSiteTasks"), { params: params });
    };
    /**
     * Get tasks filtered by status
     */
    DiaryTasksService.prototype.getTasksByStatus = function (diaryId, status, searchTerm) {
        return this.getOnsiteTasks(diaryId, status, searchTerm);
    };
    /**
     * Delete an on-site task (soft delete)
     * @param diaryId - The diary event ID
     * @param taskId - The on-site task ID
     */
    DiaryTasksService.prototype.deleteOnsiteTask = function (diaryId, taskId) {
        return this.http.delete(this.getJobApiUrl("diary/" + diaryId + "/onSiteTasks/" + taskId + "/delete"));
    };
    DiaryTasksService.ngInjectableDef = i0.defineInjectable({ factory: function DiaryTasksService_Factory() { return new DiaryTasksService(i0.inject(i1.HttpClient)); }, token: DiaryTasksService, providedIn: "root" });
    return DiaryTasksService;
}(InterfaceService));
export { DiaryTasksService };
